import React from 'react';

/**
 * WriteContext — provides write operations and action callbacks.
 *
 * null when the data source is read-only (archive/wizard providers).
 * Components should check for null before showing write-only UI elements.
 */
const WriteContext = React.createContext(null);

WriteContext.displayName = 'WriteContext';

export default WriteContext;
